<template>
  <GIPolicyDetail></GIPolicyDetail>
</template>
<script type="text/javascript">
import { GIPolicyDetail } from '../components'
export default {
  name: 'GIPolicyDetailContainer',
  created() {

  },
  components: {
    GIPolicyDetail
  }

}

</script>



// WEBPACK FOOTER //
// src/Osm/GIPolicy/containers/GIPolicyDetailContainer.vue